import { Typography } from "antd"

const { Paragraph, Link, Text } = Typography

export const vampFAQ = [
  {
    question: "What is VAMP?",
    answer: () => (
      <div>
        <Paragraph type="secondary">
          <Text>
            VAMP (Visa Acquirer Monitoring Program) is Visa’s monthly monitoring program for Visa
            transactions.
          </Text>{" "}
          It checks your fraud, disputes/chargebacks, and card-testing (”enumeration”) levels. If
          you go over Visa’s thresholds, your acquirer may require risk controls and Visa may apply
          program actions/fees. Since VAMP only uses Visa data, it can look different from your
          chargeback rate.
        </Paragraph>
        <Paragraph type="secondary">
          <Link
            href="https://www.chargeback.io/blog/what-is-visa-acquirer-monitoring-program"
            target="_blank"
          >
            Learn more about VAMP
          </Link>{" "}
          to know how to stay out of the program.
        </Paragraph>
      </div>
    )
  },
  {
    question: "Why does VAMP matter?",
    answer:
      "Staying above Visa’s thresholds for too long can lead to fines that reach tens of thousands of dollars, high reserves, or even losing your ability to process Visa cards. Tracking your VAMP data helps you catch issues early and fix them before any of these penalties begin."
  },
  {
    question: "What happens when I enter VAMP?",
    answer:
      "When you enter VAMP, your processor/acquirer will let you know and may ask for a short remediation plan. If this is your first time entering the program in the last 12 months, Visa typically gives you 90 days to get your fraud and dispute levels under the threshold before they apply fees. If you’re still over the threshold after that, Visa fees can start and your processor may add controls or limits until the numbers improve."
  },
  {
    question: "How do I get out of VAMP?",
    answer:
      "You must stay below both Visa thresholds for 3 months in a row. Once you complete those 3 months, Visa removes you from VAMP automatically. If you go above the limits again while in VAMP, the 3-month clock resets."
  },
  {
    question: "How is my VAMP status calculated?",
    answer:
      "Visa checks your Visa-only activity each month using a VAMP ratio (fraud + disputes ÷ settled Visa transactions). You enter VAMP only if, in the same month, you exceed the ratio threshold and a minimum monthly count of fraud + disputes. Visa also tracks card-testing/enumeration with separate metrics."
  },
  {
    question: "Will I be fined or have my processing limited?",
    answer:
      "Staying above the thresholds for 3 months can lead to fines, higher reserves, processing limits, or in severe cases, account termination. Your acquirer will notify you if any action is required."
  },
  {
    question: "How is VAMP different from my regular chargeback rate?",
    answer:
      "Your regular chargeback rate includes disputes from all card brands. VAMP looks only at Visa disputes and gives extra weight to fraud chargebacks. Because of this, your VAMP Rate and Count may be higher or lower than the numbers you see in your processor or CRM."
  }
]
